/***
 *
 *   PRIORITY BADGE
 *   Thin wrapper around PriorityChip so ticket surfaces can import the
 *   reference's name. Ported from ui-reference priority-badge.tsx.
 *
 **********/

import { PriorityChip } from 'components/lib';
import { useTranslate } from 'app/translations';
import { PRIORITY_STYLES } from 'components/chip/chip.tailwind.js';

export { PRIORITY_STYLES };

export function PriorityBadge(props) {
    const { _t } = useTranslate();
    const priority = props.priority || 'low';

    return (
        <PriorityChip
            priority={priority}
            label={props.label || _t(`priority.${priority}`)}
            className={props.className}
        />
    );
}
